const toFileId = (state, fileOrId) => {
  if (fileOrId instanceof File) {
    return state.fileIdByFile.get(fileOrId);
  }
  return fileOrId;
};
export {
  toFileId
};
//# sourceMappingURL=toFileId.js.map
